export default __webpack_public_path__ + "static/media/light.2b690f2e.svg";